<template>
    <section class="main-section best-seller" v-if="form?.main_bookOfTheMonth?.uses">
        <v-container>
            <div class="tit-wrap text-center">
                <h2 class="tit tit--lg">이달의 추천 도서</h2>
            </div>

            <v-sheet>
                <v-row>
                    <v-col cols="12" md="4">
                        <v-card elevation="0" v-bind="{ to }">
                            <v-img :aspect-ratio="2 / 3" :src="form?.main_bookOfTheMonth?.product?.thumb" content-class="d-flex justify-center align-center">
                                <template v-if="!form?.main_bookOfTheMonth?.product?.thumb">
                                    <v-icon x-large>mdi-image-broken-variant</v-icon>
                                </template>
                            </v-img>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="8">
                        <v-layout column fill-height>
                            <v-chip-group column>
                                <template v-for="item in form.main_bookOfTheMonth.tags">
                                    <v-chip outlined large class="rounded-xl" :key="item">#{{ item }}</v-chip>
                                </template>
                            </v-chip-group>

                            <v-spacer />

                            <v-card-title class="px-0"> {{ form?.main_bookOfTheMonth?.name || form?.main_bookOfTheMonth?.product?.name }} </v-card-title>
                            <v-card-subtitle class="px-0 grey--text">
                                {{ form?.main_bookOfTheMonth?.writer || form?.main_bookOfTheMonth?.product?.writer }} |
                                {{ form?.main_bookOfTheMonth?.publisher || form?.main_bookOfTheMonth?.product?.publisher }}
                                <br />
                                <strong> {{ (form?.main_bookOfTheMonth?.salePrice || form?.main_bookOfTheMonth?.product?.salePrice || 0)?.format?.() }} 원 </strong>
                            </v-card-subtitle>
                            <v-card-text class="px-0 grey--text">
                                {{ form?.main_bookOfTheMonth?.text }}
                            </v-card-text>
                        </v-layout>
                    </v-col>
                </v-row>
            </v-sheet>
        </v-container>
    </section>
</template>

<script>
import api from "@/api";

const initForm = (form = {}) => ({
    ...(form || {}),
    main_bookOfTheMonth: {
        ...(form?.main_bookOfTheMonth || {}),

        uses: form?.main_bookOfTheMonth?.uses || false,

        _product: form?.main_bookOfTheMonth?._product || null,

        href: form?.main_bookOfTheMonth?.href || null,
        name: form?.main_bookOfTheMonth?.name || null,
        text: form?.main_bookOfTheMonth?.text || null,
        tags: form?.main_bookOfTheMonth?.tags || null,
        writer: form?.main_bookOfTheMonth?.writer || null,
        publisher: form?.main_bookOfTheMonth?.publisher || null,
        salePrice: form?.main_bookOfTheMonth?.salePrice || null,
    },
});

export default {
    data: () => ({
        form: initForm(),
    }),
    computed: {
        to() {
            return this.form?.main_bookOfTheMonth?.href || `/shop/products/${this.form?.main_bookOfTheMonth?._product}`;
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            let { setting } = await api.v1.common.setting.get();
            this.form = initForm(setting);
        },
    },
};
</script>

<style></style>
